<div class="tenant-form">
    <div class="back">
        <button type="button" routerLink="/admin/tenants">
            <span class="icon-anchor-top"></span>
            <span>Back to Tenant Management</span>
        </button>
    </div>

    <h3 class="title">{{ title() }}</h3>

    <form [formGroup]="form">
        <div class="field">
            <h5 class="field-title">Show or Channel Name</h5>
            <tools-input-outline
                label="Show or Channel Name"
                placeholder="Enter name"
                formControlName="name"
            ></tools-input-outline>
        </div>

        <div class="field">
            <h5 class="field-title">Description</h5>
            <tools-textarea
                placeholder="Enter a description"
                [maxLength]="descriptionMaxLength"
                formControlName="description"
            ></tools-textarea>
        </div>

        <div class="field">
            <mat-form-field class="dropdown">
                <mat-label>Assign Theme</mat-label>
                <mat-select formControlName="themeId">
                    @for (theme of themes(); track theme.id) {
                        <mat-option [value]="theme.id">
                            {{ theme.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="field">
            <h5 class="field-title">Assign Entity ID</h5>
            <p class="hint">
                Connect this tenant to an Atlas show or channel so its
                interactives appear in the app.
            </p>
            <tools-input-outline
                label="Assign Entity ID"
                placeholder="Enter Entity ID"
                formControlName="entityId"
            ></tools-input-outline>
            @if (entityIdFormatError()) {
                <span class="error">
                    Enter a show or channel Entity ID, including its prefix (for
                    example SH:1234 or LC:1234).
                </span>
            }
        </div>

        <div class="field">
            <h5 class="field-title">Search Keywords</h5>
            <p class="hint">
                Add keywords listeners might use to find this tenant’s
                interactives in the app. Press Enter after each keyword.
            </p>
            <!-- Keywords sit above the input (per design) and wrap onto extra rows, pushing the
                 field down as they're added. -->
            @if (hasKeywords()) {
                <app-tag-list
                    class="keywords"
                    formControlName="searchAliases"
                />
            }
            <tools-input-outline
                label="Search Keywords"
                placeholder="Enter keyword"
                [formControl]="keyword"
                (keydown.enter)="addKeyword($event)"
            ></tools-input-outline>
            @if (isKeywordLimitReached()) {
                <span class="hint error">
                    You’ve added the maximum of {{ maxKeywords }} keywords.
                    Remove one to add another.
                </span>
            }
        </div>

        <div class="toggle-field">
            <tools-toggle formControlName="prioritizeOverCallIn">
                Override Call In button
            </tools-toggle>
            <p class="hint">
                When turned on, the
                <span class="body-1">Reply Now</span>
                button replaces the
                <span class="body-1">Call In</span>
                button in the player when both are available. Listeners can
                still access both options from the player menu.
            </p>
        </div>
    </form>

    <div class="action-bar">
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            routerLink="/admin/tenants"
        >
            Cancel
        </tools-button>
        <tools-button [isDisabled]="isSubmitDisabled()" (onClick)="onSubmit()">
            {{ primaryLabel() }}
        </tools-button>
    </div>
</div>
